export const squash = (json) => {
  var result = [];

  ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L"].forEach(col => {
    result.push(json[0][col]);
  });

  return result;
}